import type React from "react";

export const EditIcon: React.FC = () => {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.83333 12.1775L7.51083 12.165L15.5375 4.21502C15.8525 3.90002 16.0258 3.48169 16.0258 3.03669C16.0258 2.59169 15.8525 2.17335 15.5375 1.85835L14.2158 0.536687C13.5858 -0.0933129 12.4867 -0.0899796 11.8617 0.534187L3.83333 8.48585V12.1775ZM13.0375 1.71502L14.3617 3.03419L13.0308 4.35252L11.7092 3.03169L13.0375 1.71502ZM5.5 9.18085L10.525 4.20335L11.8467 5.52502L6.8225 10.5009L5.5 10.505V9.18085Z"
        fill="currentColor"
      />
      <path
        d="M2.16667 15.5H13.8333C14.7525 15.5 15.5 14.7525 15.5 13.8333V6.61L13.8333 8.27667V13.8333H4.79833C4.77667 13.8333 4.75417 13.8417 4.7325 13.8417C4.705 13.8417 4.6775 13.8342 4.64917 13.8333H2.16667V2.16667H7.8725L9.53917 0.5H2.16667C1.2475 0.5 0.5 1.2475 0.5 2.16667V13.8333C0.5 14.7525 1.2475 15.5 2.16667 15.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
